export const SNOWPLOW_EVENTS = {
    MENU_ITEM: {
        category: 'guest_app__menu_item',
        action: 'button_clicked',
        label: 'menu_item',
    },
    CART_ADD_ITEM: {
        category: 'guest_app__cart',
        action: 'button_clicked',
        label: 'add_to_cart',
    },
    CART_REMOVE_ITEM: {
        category: 'guest_app__cart',
        action: 'button_clicked',
        label: 'remove_from_cart',
    },
    CART_CHECKOUT: {
        category: 'guest_app__cart',
        action: 'button_clicked',
        label: 'checkout',
    },
    MESSAGE_CREATE: {
        category: 'guest_app__messages',
        action: 'button_clicked',
        label: 'send',
    },
    REVIEW_CREATE: {
        category: 'guest_app__reviews',
        action: 'button_clicked',
        label: 'send',
    },
}
export function addSnowplowStructEvent(event) {
    if (window.snowplow) {
        window.snowplow('trackStructEvent', event);
    } else {
        console.log('snowplow is not defined');
    }
}
